export const selectCustomFields = state => state.customFields ? state.customFields.data : null

export const selectFetchingCustomFields = state => state.customFields ? state.customFields.fetching : false
